import { render, staticRenderFns } from "./legalMaintenance.vue?vue&type=template&id=214b384a&scoped=true&"
import script from "./legalMaintenance.vue?vue&type=script&lang=js&"
export * from "./legalMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./legalMaintenance.vue?vue&type=style&index=0&id=214b384a&prod&scoped=true&lang=css&"
import style1 from "./legalMaintenance.vue?vue&type=style&index=1&id=214b384a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b384a",
  null
  
)

export default component.exports